// actions/ApiCalls.ts
import api from "../api";

export function getDocuments() {
    return api.get('/dashboard/documents/all');
}

export interface DocumentPayload {
    title: string;
    document: File;
    userId?: number | string;
}


export function addDocument({ title, document, userId }: DocumentPayload) {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('document', document);

    return api.post(`/dashboard/documents/store/${userId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function deleteDocument(id: number) {
    return api.post(`/dashboard/documents/delete/${id}`);
}
